import { ButtonHTMLAttributes, DetailedHTMLProps, forwardRef } from 'react';
import clsx from 'clsx';

export type ButtonVariant = 'primary' | 'secondary' | 'link' | 'clear';
export type ButtonSize = 'small' | 'large';

export interface ButtonProps
  extends DetailedHTMLProps<
    ButtonHTMLAttributes<HTMLButtonElement>,
    HTMLButtonElement
  > {
  variant?: ButtonVariant;
  size?: ButtonSize;
  fullWidth?: boolean;
}

export const Button = forwardRef<HTMLButtonElement, ButtonProps>(
  (
    {
      children,
      className: classNameProp,
      variant = 'primary',
      size = 'large',
      fullWidth = false,
      ...rest
    },
    ref,
  ) => {
    const className = clsx(
      'mel-button',
      classNameProp,
      `mel-button--${variant}`,
      `mel-button--${size}`,
      { ['mel-button-full']: fullWidth },
    );

    return (
      <button ref={ref} className={className} {...rest}>
        {children}
      </button>
    );
  },
);
